import CryptoJS from "crypto-js";
import variables from "../themes/base/styles/variables";
import {
  AUDIT_MEDIUM,
  auditCreationYear,
  auditStatuses,
  currentAuditType,
  DB_DATE_FORMAT,
  userRole,
} from "../constants";
import { showNotification } from "./notification";
import moment from "moment";
import jwt_decode from "jwt-decode";

export const encrypt = (text) => {
  return CryptoJS.AES.encrypt(
    text,
    process.env.REACT_APP_ENCRYPTION_KEY
  ).toString();
};

export const decrypt = (encryptedText) => {
  return CryptoJS.AES.decrypt(
    encryptedText,
    process.env.REACT_APP_ENCRYPTION_KEY
  ).toString(CryptoJS.enc.Utf8);
};

export const decryptAuthData = (authorizationData) => {
  const authorization = jwt_decode(decrypt(authorizationData));
  return {
    data: {
      email: authorization?.email,
      id: authorization?.id,
      name: authorization?.name,
      isEmailNotification: authorization?.isEmailNotification,
      isSmsNotification: authorization?.isSmsNotification,
      isWebPortalNotification: authorization?.isWebPortalNotification,
      roles: authorization?.roles,
      conversationToken: authorization?.conversationToken,
      conversationSid: authorization?.conversationSid,
    },
    authorization: authorizationData,
    currentRole: authorization?.roles?.filter(
      (roleItem) => roleItem?.id === authorization?.currentRole
    )?.[0],
  };
};

export function getLocalizedMessage(intl, id, params) {
  return intl.formatMessage({ id }, params);
}

export const getColor = (level) => {
  switch (level) {
    case 1:
      return variables.purple;
    case 2:
      return variables.cyan;
    case 3:
      return variables.green;
    case 4:
      return variables.pink;
    default:
      return variables.grey1;
  }
};
export function getFilterData(
  productCategoryApiRes = [],
  userTypeApiData = [],
  countriesList = []
) {
  return [
    {
      value: "Product & sub-product category",
      label: "Product & sub-product category",
      placeholder: "Search Products",
      children: addPlaceholders(
        getProductAndSubProductCategoryFilterOption(productCategoryApiRes)
      ),
    },
    {
      value: "User Type",
      label: "User Type",
      children: getUserTypeOptions(userTypeApiData),
    },
    countriesList?.length && {
      value: "Country",
      label: "Country",
      children: countriesList?.map(({ id: value, name: label }) => ({
        value,
        label,
      })),
    },
  ].filter(Boolean);
}

function getProductAndSubProductCategoryFilterOption(productCategoryApiData) {
  return productCategoryApiData.map(
    ({ productCategoryId, productCategoryName, subCategory }) => ({
      value: `${productCategoryId}_pc`,
      label: productCategoryName,
      ...(subCategory?.length && {
        children: subCategory.map(({ id, name: label }) => ({
          label,
          value: `${id}_spc`,
        })),
      }),
    })
  );
}

function getUserTypeOptions(rolesApiData) {
  return rolesApiData.map(({ id, name, fullName }) => ({
    value: `${id}_${name}`,
    label: fullName,
  }));
}

function addPlaceholders(data, level = 0) {
  return data.map((item) => {
    const newItem = { ...item };

    if (newItem.children && newItem.children.length > 0) {
      newItem.children = addPlaceholders(newItem.children, level + 1);
    }

    if (level === 0) {
      newItem.placeholder = "Search Products";
    } else if (level === 1) {
      newItem.placeholder = "Search Sub Products";
    }

    return newItem;
  });
}

export function flattenOptions(options) {
  let flattenedOptions = [];

  options.forEach((option) => {
    const { children, ...rest } = option;
    flattenedOptions.push(rest);

    if (children) {
      const nestedOptions = flattenOptions(children);
      flattenedOptions = flattenedOptions.concat(nestedOptions);
    }
  });

  return flattenedOptions;
}

export function getProductAndSubcategoryFromFilterData(item) {
  const subCategory = [];
  const productCategory = [];

  if (item.children) {
    const children = item.children;

    children.forEach((child) => {
      if (
        child?.isSelected ||
        child?.children?.some(({ isSelected }) => isSelected)
      ) {
        productCategory.push(child.value);
      }
      if (child.children) {
        const grandChildren = child.children;

        grandChildren.forEach((grandChild) => {
          if (grandChild.isSelected) {
            subCategory.push(grandChild.value);
          }
        });
      }
    });
  }
  return [
    productCategory.map((product_category) => product_category.split("_")[0]),
    subCategory.map((sub_category) => sub_category.split("_")[0]),
  ];
}

export function getSelectedRolesIds(item) {
  const rolesId = [];
  if (item.children) {
    const children = item.children;

    children.forEach((child) => {
      if (child.isSelected) {
        rolesId.push(child.value);
      }
    });
  }
  return rolesId.map((roleId) => roleId.split("_")[0]);
}

export function getSelectedStatus(item) {
  const status = [];
  if (item.children) {
    const children = item.children;

    children.forEach((child) => {
      if (child.isSelected) {
        status.push(child.value);
      }
    });
  }
  return status;
}

export function getSelectedCountries(item = {}) {
  const countries = [];
  if (item.children) {
    const children = item.children;

    children.forEach((child) => {
      if (child.isSelected) {
        countries.push(child.value);
      }
    });
  }
  return countries;
}

export function getSelectedFilterItem(item) {
  const filterItem = [];
  if (item.children) {
    const children = item.children;

    children.forEach((child) => {
      if (child.isSelected) {
        filterItem.push(child.value);
      }
    });
  }
  return filterItem;
}

export function addCheckedKeysToProduct(productSubProductsOptions) {
  return productSubProductsOptions?.map((product) => ({
    ...product,
    name: product.productCategoryName,
    checked: product.checked || false,
    id: product.productCategoryId,
    subCategory: product.subCategory.map((subCategoryProduct) => ({
      ...subCategoryProduct,
      name: subCategoryProduct.name,
      checked: subCategoryProduct.checked || false,
      id: subCategoryProduct.id,
    })),
  }));
}

export function getCheckedProductsForEdit(
  productSubProductsOptions,
  dnsdCategories
) {
  return () => {
    return addCheckedKeysToProduct(productSubProductsOptions).map(
      (prevCategory) => {
        const updatedCategory = { ...prevCategory };
        const foundCategory = dnsdCategories.find(
          (category) => prevCategory.id === category.productCategoryId
        );
        if (!foundCategory) return updatedCategory;
        const foundSubCategories = foundCategory.subCategory;

        updatedCategory.checked = foundCategory.subCategory.length > 0;

        updatedCategory.subCategory = updatedCategory.subCategory.map(
          (prevSubCategory) => {
            const updatedSubCategory = { ...prevSubCategory };
            const foundSubCategory = foundSubCategories.find(
              (subCategory) =>
                subCategory.subCategoryId === updatedSubCategory.id
            );

            if (!foundSubCategory) return updatedSubCategory;

            updatedSubCategory.checked = true;

            return updatedSubCategory;
          }
        );

        return updatedCategory;
      }
    );
  };
}

export function getQuestionnaireTypeOptions(questionnaireTypeData) {
  return questionnaireTypeData.map(({ id, name, fullName }) => ({
    value: name,
    label: fullName,
  }));
}

export function getFilterDataForQuestionnaireListing(
  questionnaireTypeData = [],
  productCategoryApiRes = []
) {
  return [
    {
      value: "Questionnaire type",
      label: "Questionnaire type",
      children: getQuestionnaireTypeOptions(questionnaireTypeData),
      disableAllOn: "is_operational_audit",
      notDisabledOn: "is_repair_audit",
    },
    {
      value: "Product & sub-product category",
      label: "Product & sub-product category",
      placeholder: "Search Products",
      children: addPlaceholders(
        getProductAndSubProductCategoryFilterOption(productCategoryApiRes)
      ),
    },
  ];
}

export function getSelectedQuestionnaireTypes(item) {
  const questionnaireTypesId = [];
  if (item?.children) {
    const children = item.children;

    children.forEach((child) => {
      if (child.isSelected) {
        questionnaireTypesId.push(child.value);
      }
    });
  }
  return questionnaireTypesId;
}

export const getValidationObject = (array = []) =>
  array?.reduce((output, item) => {
    const countryCode = item.code.replace(/\D/g, "");
    output[countryCode] = new RegExp(item.regex.slice(1, -1));
    return output;
  }, {});
export const auditType = [
  { value: "Operational", label: "Operational" },
  { value: "Repair", label: "Repair" },
];
export function getAuditListingFilterData(
  productCategoryApiRes = [],
  countriesList = [],
  isDashboard = false,
  DnsdList = []
) {
  return [
    {
      value: "Product & sub-product category",
      label: "Product & sub-product category",
      placeholder: "Search Products",
      children: addPlaceholders(
        getProductAndSubProductCategoryFilterOption(productCategoryApiRes)
      ),
    },
    countriesList?.length && {
      value: "Country",
      label: "Country",
      children: countriesList?.map(({ id: value, name: label }) => ({
        value,
        label,
      })),
    },
    {
      value: "Current audit type",
      label: isDashboard ? "Audit type" : "Current audit mode",
      children: (isDashboard ? auditType : currentAuditType)?.map(
        ({ value, label }) => ({
          value,
          label,
        })
      ),
    },
    {
      value: "Audit creation year",
      label: isDashboard ? "Year" : "Audit creation year",
      children: auditCreationYear?.map(({ value, label }) => ({
        value,
        label,
      })),
    },
    !isDashboard && {
      value: "Status",
      label: "Status",
      children: auditStatuses?.map(({ value, label }) => ({
        value,
        label,
      })),
    },
    isDashboard && {
      value: "DNSD",
      label: "DNSD",
      children: DnsdList?.map(({ id, name }) => ({
        value: id,
        label: name,
      })),
    },
  ].filter(Boolean);
}

export function getDashboardFilterData(
  productCategoryApiRes = [],
  countriesList = [],
  DnsdList = []
) {
  return [
    {
      value: "Product & sub-product category",
      label: "Product & sub-product category",
      placeholder: "Search Products",
      children: addPlaceholders(
        getProductAndSubProductCategoryFilterOption(productCategoryApiRes)
      ),
    },
    countriesList?.length && {
      value: "Country",
      label: "Country",
      children: countriesList?.map(({ id: value, name: label }) => ({
        value,
        label,
      })),
    },
    {
      value: "Current audit type",
      label: "Audit type",
      children: auditType?.map(({ value, label }) => ({
        value,
        label,
      })),
    },
    {
      value: "Audit creation year",
      label: "Year",
      children: auditCreationYear?.map(({ value, label }) => ({
        value,
        label,
      })),
    },
    {
      value: "DNSD",
      label: "DNSD",
      children: DnsdList?.map(({ id, name }) => ({
        value: id,
        label: name,
      })),
    },
  ].filter(Boolean);
}

export function getDnsdFilterData(DnsdList) {
  return DnsdList?.map(({ id, name }) => ({
    value: id,
    label: name,
  }));
}

export function getSubCategoryFilterData(productCategoryApiRes = []) {
  return productCategoryApiRes.flatMap((item) =>
    item.subCategory.map(({ id, name }) => ({
      value: id,
      label: name,
    }))
  );
}

export function getRepairAudit({
  role,
  isRepairAuditForDNSD,
  isRepairAuditForTM,
}) {
  let isRepairAudit;
  if (role === userRole.DNSD) {
    isRepairAudit = isRepairAuditForDNSD;
  } else if (role === userRole.TM) {
    isRepairAudit = isRepairAuditForTM;
  } else {
    isRepairAudit = false;
  }
  return isRepairAudit;
}

export function getOperationAudit({ role, isOperationAuditForTM }) {
  let isOperationsAudit;
  if (role === userRole.DNSD) {
    isOperationsAudit = true;
  } else if (role === userRole.TM) {
    isOperationsAudit = isOperationAuditForTM;
  } else {
    isOperationsAudit = false;
  }
  return isOperationsAudit;
}

export function getConditionalContent({ condition, trueValue, falseValue }) {
  return condition ? trueValue : falseValue;
}

export const downloadReports = (response) => {
  const url = window.URL.createObjectURL(new Blob([response?.data]));
  let filename = response?.headers["content-disposition"]
    .split("filename=")[1]
    .replace(/"/g, "");
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  link.click();
};

export function getValueOnCondition({ condition, trueValue, falseValue }) {
  return condition ? trueValue : falseValue;
}

export function hideLoaderShowErrorMsg({ loaderDispatch, setLoading, intl }) {
  loaderDispatch(setLoading(false));
  showNotification(
    "error",
    "Error",
    getLocalizedMessage(intl, "error.somethingWentWrong")
  );
}

export function getFinancialYearMonths(valuePlannedMonth) {
  const currentMonth = new Date().getMonth();
  if (currentMonth > 3) {
    for (let i = 3; i < currentMonth; i++) {
      valuePlannedMonth[i].disabled = true;
    }
  } else {
    for (let i = 0; i < currentMonth; i++) {
      valuePlannedMonth[i].disabled = true;
    }
  }
  return [...valuePlannedMonth.slice(3), ...valuePlannedMonth.slice(0, 3)];
}
export const formatDuration = (durationInSeconds) => {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = durationInSeconds % 60;

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export function disabledDate(current, allowFutureDates = false) {
  // Get today's date
  const today = new Date();

  // Allow all dates in the current financial year
  //const currentYear = today.getFullYear();
  const currentYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  const financialYearStart = new Date(currentYear, 3, 1); // April is month 3 (0-indexed)
  const nextFinancialYearStart = new Date(currentYear + 1, 3, 1);
  const financialYearEnd = new Date(nextFinancialYearStart.getTime() - 1);

  if (!allowFutureDates) {
    return (
      current && (current < financialYearStart || current > financialYearEnd)
    );
  } else {
    if (current < financialYearStart) {
      return true;
    }

    // Disable all dates in the past
    if (current < today) {
      return true;
    }

    // Allow all other dates
    return false;
  }
}

export function getIsAudit() {

  const url = new URL(window.location.href);
  const path = url.pathname;

  return (
    (path.includes("audit") &&
      !path.includes("audit-preview") &&
      !path.includes("dnsd")) ||
    path.includes("dnsd/audit/self/") ||
    path.includes("dnsd/audit/remote/")
  );
}

export function getLabelText(isAudit, role, auditMedium) {
  if (isAudit) {
    if (role === userRole.DNSD || auditMedium === AUDIT_MEDIUM.SELF) {
      return "manageAudit.SelfHeading";
    } else if (auditMedium === AUDIT_MEDIUM.REMOTE) {
      return "manageAudit.RemoteHeading";
    } else {
      return "manageAudit.F2FHeading";
    }
  } else {
    return "manageAudit.previewAudit";
  }
}
export const formatDate = (date, intl) => {
  return moment(date, DB_DATE_FORMAT).format(
    getLocalizedMessage(intl, "auditListing.displayDateFormat")
  );
};

export const formatMonth = (date, intl) => {
  return moment(date, DB_DATE_FORMAT).format(
    getLocalizedMessage(intl, "auditListing.displayMonthFormat")
  );
};

export function getIsTokenExpired(expiryTimestamp) {
  const currentTime = moment().unix(); // get current Unix timestamp
  return currentTime > expiryTimestamp; // compare timestamps
}

export function getQueryParams(paramsString) {
  return decodeURIComponent(
    new URLSearchParams(window.location.search).get(paramsString)
  ); // this returns the URL query parameter
}

export function downloadImageLink(linkLabel, dataUrl) {
  const link = document.createElement("a");
  link.download = linkLabel;
  link.href = dataUrl;
  link.click();
}

export function getFileNameFromHeaders(string) {
  const filenameRegex = /filename="([^"]+)"/;
  const matches = string.match(filenameRegex);
  const fileName = matches ? matches[1] : null;
  return moment(Number(fileName)).format("DD MMM,YY HH:mm:ss");
}

export function getDayWiseNotification(messages) {
  // Create a map to group messages by their creation day
  const groupedMessages = messages.reduce((acc, message) => {
    const createdAt = new Date(message.created_at);
    const day = createdAt.toISOString().split("T")[0]; // Extract day in "YYYY-MM-DD" format

    if (!acc[day]) {
      acc[day] = [];
    }

    acc[day].push(message);

    return acc;
  }, {});

  // Convert the groupedMessages map into the desired format
  const currentDate = new Date();
  const today = currentDate.toISOString().split("T")[0];
  const yesterday = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

  return Object.keys(groupedMessages).map((day) => {
    let displayDay;

    if (day === today) {
      displayDay = "Today";
    } else if (day === yesterday) {
      displayDay = "Yesterday";
    } else {
      displayDay = day;
    }

    return {
      day: displayDay,
      notifications: groupedMessages[day],
    };
  });
}

export function isIOSDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isMultipleCameraDevice(auditDispatch, setMultipleCamera,facingMode) {
  if (setMultipleCamera && auditDispatch) {
    if (isIOSDevice()) {
      auditDispatch(setMultipleCamera(true));
      return;
    }

    navigator.mediaDevices
      .getUserMedia({ video: { facingMode} })
      .then(() => {
        // Check if there's more than one video input device
        navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            const videoInputDevices = devices.filter(
              (device) => device.kind === "videoinput"
            );
            auditDispatch(setMultipleCamera(videoInputDevices.length > 1));
          })
          .catch((error) => {
            console.error("Error enumerating devices.", error);
          });
      })
      .catch((error) => {
        console.error("Error accessing the camera", error);
      });
  }
}

export function getDashboardQueryParams(filter, isPercentage = false) {
  let queryParams = {
    isPercentage,
  };
  if (filter?.subCategories) {
    queryParams = {
      ...queryParams,
      subProductCategoryId: filter.subCategories,
    };
  }
  if (filter?.countries) {
    queryParams = {
      ...queryParams,
      countryId: filter.countries,
    };
  }
  if (filter?.year) {
    queryParams = {
      ...queryParams,
      year: filter.year,
    };
  }
  if (filter?.auditType) {
    queryParams = {
      ...queryParams,
      type: filter.auditType,
    };
  }
  if (filter?.DNSD) {
    queryParams = {
      ...queryParams,
      dnsdId: filter.DNSD,
    };
  }
  if (queryParams?.auditType === "Operational")
    delete queryParams.subProductCategoryId;

  return queryParams;
}